import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";

interface AuditLogsState {
  data: any | null;
  loading: "idle" | "pending" | "fulfilled" | "rejected";
  error: string | null;
  action: "list" | null;
}
const initialState: AuditLogsState = {
  data: null,
  loading: "idle",
  error: null,
  action: null,
};
export const getAuditLogs: any = createAsyncThunk(
  "audit/logs",
  async (requestBody: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.AUDIT_LOGS,
        requestBody
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

export const getAdminActivityLogs: any = createAsyncThunk(
  "adminActivity/logs",
  async (requestBody: any, thunkAPI) => {
    try {
      const payload = {
        page: requestBody?.page || 1,
        limit: requestBody?.limit || 20,
        orderColumn: requestBody?.orderColumn || "created_at",
        orderBy: requestBody?.orderBy || "DESC",
        ...requestBody,
      };
      const response = await Api.post(
        API_URLS.ADMIN_ACTIVITY_LOGS,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const auditLogSlice = createSlice({
  name: "reset",
  initialState: initialState,
  reducers: {
    resetAll: (state: any) => {
      state.loading = "idle";
      state.error = null;
      state.action = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAuditLogs.pending, (state) => {
        state.loading = "pending";
        state.error = null;
        state.action = "list";
      })
      .addCase(getAuditLogs.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getAuditLogs.rejected, (state, action) => {
        state.loading = "rejected";
        state.error = action.payload;
      })
      .addCase(getAdminActivityLogs.pending, (state) => {
        state.loading = "pending";
        state.error = null;
        state.action = "list";
      })
      .addCase(getAdminActivityLogs.fulfilled, (state, action) => {
        state.loading = "fulfilled";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getAdminActivityLogs.rejected, (state, action) => {
        state.loading = "rejected";
        state.error = action.payload;
      });
  },
});
export const { resetAll } = auditLogSlice.actions;
export default auditLogSlice.reducer;
